import { render, staticRenderFns } from "./KnFormAssignTeacherAndSubjectToGroup.vue?vue&type=template&id=a729df70"
import script from "./KnFormAssignTeacherAndSubjectToGroup.js?vue&type=script&lang=js&external"
export * from "./KnFormAssignTeacherAndSubjectToGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports